export default __webpack_public_path__ + "static/media/free-channel-img.3f3b94b3.png";